var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-photo is-flex is-justify-content-center is-align-items-center"},[_c('figure',{staticClass:"image is-128x128 is-128x128-mobile"},[_c('img',{staticClass:"is-rounded",attrs:{"src":_vm.avatarUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }